import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {transactionPerformancePaymentCategory_template} from "./transactionPerformancePaymentCategory_template";
import {transactionPremiumPaymentCategory_template} from "./transactionPremiumPaymentCategory_template";
import {PaymentCategorySystem} from "../../utils/types/payment_categories";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;


export class transactionPaymentCategory_template extends vnTemplate {

    public premiumPaymentCategorySystemTemplate: transactionPremiumPaymentCategory_template;
    public performancePaymentCategorySystemTemplate: transactionPerformancePaymentCategory_template;
    public validationsList: validationsList_template;

    protected getTemplateName(): string {
        return "transactionPaymentCategory_template";
    }

    protected getTemplateHtml(): string {
        return `
            <div id="transaction-payment-systems-list-results" class=" list-results w-form w-transaction-payment-systems">
                ${this.validationsList.getHtmlBuild()}
                <div class="form-header" >
                    <h3 class="form-title icon i-target">Transaction Payment Categories</h3>
                </div>
                <div class="form-pagination">
                    <button class="btn icon i-premium" type="button" data-bind="event: { click: onClickTab.bind($data, 'premium') }, css: { 'is-activated' : system() == 'premium'}">
                        <span class="btn-text">Premium Categories</span>
                    </button>
                    <button class="btn icon i-performance" type="button" data-bind="event: { click: onClickTab.bind($data, 'performance') }, css: { 'is-activated' : system() == 'performance'}">
                        <span class="btn-text">Performance Categories</span>
                    </button>
                </div>
                <div class="" data-bind="visible: (system() == 'premium')">
                    ${this.premiumPaymentCategorySystemTemplate.getHtmlBuild()}
                </div>
                <div class="" data-bind="visible: system() == 'performance'">
                    ${this.performancePaymentCategorySystemTemplate.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form-body"];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            filterBySystem: ko.observable(false),
            system: ko.observable(PaymentCategorySystem.PREMIUM),
            paymentCategories: ko.observableArray([]),
            onClickTab: (value, data, event): void => {
                self.onClickTab(value);
            }
        };
    }

    protected initPartial() {
        this.premiumPaymentCategorySystemTemplate = new transactionPremiumPaymentCategory_template('premiumPaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        this.premiumPaymentCategorySystemTemplate.setParent(this);
        this.premiumPaymentCategorySystemTemplate.setSystem(PaymentCategorySystem.PREMIUM);

        this.performancePaymentCategorySystemTemplate = new transactionPerformancePaymentCategory_template('performancePaymentCategoryTabTemplate', this.getTemplateViewModel(), this.caller);
        this.performancePaymentCategorySystemTemplate.setParent(this);
        this.performancePaymentCategorySystemTemplate.setSystem(PaymentCategorySystem.PERFORMANCE);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected onClickTab(tab): void {
        this.setSystem(tab);
        this.setFilterBySystem(true);
    }

    public setTransactionPaymentCategoriesFromServer(systems: { premium: any, performance: any }): void {

        if (systems.premium) {
            this.premiumPaymentCategorySystemTemplate.setTransactionPaymentCategoriesFromServer(systems.premium);
        }
        if (systems.performance) {
            this.performancePaymentCategorySystemTemplate.setTransactionPaymentCategoriesFromServer(systems.performance);
        }
    }

    public getSystem(): string {
        return this.getTemplateViewModel().system();
    }

    public setSystem(system): string {
        return this.getTemplateViewModel().system(system);
    }

    public isPerformanceSystem(): boolean {
        let system = this.getSystem();

        return (system === PaymentCategorySystem.PERFORMANCE);
    }

    /**
     * Returns a list of session brands to be saved in the system
     */
    public getViewModelForRequest() {

        if (this.isPerformanceSystem()) {
            return this.performancePaymentCategorySystemTemplate.getViewModelForRequest();
        } else {
            return this.premiumPaymentCategorySystemTemplate.getViewModelForRequest();
        }
    }


    public getTransactionPaymentCategories() {
        if (this.isPerformanceSystem()) {
            return this.performancePaymentCategorySystemTemplate.getTransactionPaymentCategories();
        } else {
            return this.premiumPaymentCategorySystemTemplate.getTransactionPaymentCategories();
        }
    }

    public getPostRequestData() {
        if (this.isPerformanceSystem()) {
            return this.performancePaymentCategorySystemTemplate.getPostRequestData();
        } else {
            return this.premiumPaymentCategorySystemTemplate.getPostRequestData();
        }
    }

    public getGetRequestData() {
        if (this.isPerformanceSystem()) {
            return this.performancePaymentCategorySystemTemplate.getGetRequestData();
        } else {
            return this.premiumPaymentCategorySystemTemplate.getGetRequestData();
        }
    }

    public setFilterBySystem(filterBySystem): void {
        this.getTemplateViewModel().filterBySystem(filterBySystem);
    }

    public isFilterBySystem(): boolean {
        return this.getTemplateViewModel().filterBySystem();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/transactionPaymentCategory_template.ts